import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import './login.css';

const Login = () => {
  const navigate = useNavigate();
  const { autenticar, autenticado } = useAuth();

  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (autenticado) {
      navigate('/', { replace: true });
    }
  }, [autenticado, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const resultado = autenticar(login, senha);
    if (!resultado.ok) {
      setErro(resultado.mensagem);
      return;
    }

    setErro('');
    navigate('/', { replace: true });
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Controle de Eventos</h1>
        <p>Entre com seu login e senha</p>

        <label htmlFor="login">Login</label>
        <input
          id="login"
          type="text"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          placeholder="Ex: admin"
          autoComplete="username"
        />

        <label htmlFor="senha">Senha</label>
        <input
          id="senha"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          placeholder="Sua senha"
          autoComplete="current-password"
        />

        {erro && <div className="login-erro">{erro}</div>}

        <button type="submit" className="btn btn-primary">
          Entrar
        </button>

        <small className="login-dica">Credenciais de teste: admin / Admin@123</small>
      </form>
    </div>
  );
};

export default Login;
